/* Vexoria — "Estudio de pausa" */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fino = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function observar(sel, cb, opts) {
    var els = document.querySelectorAll(sel);
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { cb(e); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { cb(x.target); io.unobserve(x.target); } });
    }, opts || { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function partirPalabras() {
    document.querySelectorAll('[data-ep-palabras]:not([data-ep-ok])').forEach(function (el) {
      el.setAttribute('data-ep-ok', '1');
      var i = 0;
      (function walk(n) {
        Array.prototype.slice.call(n.childNodes).forEach(function (c) {
          if (c.nodeType === 3) {
            var frag = document.createDocumentFragment();
            c.textContent.split(/(\s+)/).forEach(function (w) {
              if (!w) return;
              if (/^\s+$/.test(w)) { frag.appendChild(document.createTextNode(w)); return; }
              var o = document.createElement('span'); o.className = 'ep-w';
              var s = document.createElement('span'); s.style.setProperty('--i', i++); s.textContent = w;
              o.appendChild(s); frag.appendChild(o);
            });
            c.parentNode.replaceChild(frag, c);
          } else if (c.nodeType === 1 && c.tagName !== 'BR') { walk(c); }
        });
      })(el);
    });
  }

  function reveals() {
    observar('.ep-rv:not(.is-in)', function (e) { e.classList.add('is-in'); });
    observar('[data-ep-palabras]:not(.is-in)', function (e) { e.classList.add('is-in'); }, { threshold: 0.2 });
    observar('.ep-hero:not(.is-in)', function (e) { e.classList.add('is-in'); }, { threshold: 0.05 });
  }

  function contar() {
    observar('[data-ep-contar]:not([data-ep-ok])', function (el) {
      el.setAttribute('data-ep-ok', '1');
      var fin = parseFloat(el.getAttribute('data-ep-contar')) || 0;
      if (reduce || fin === 0) { el.textContent = fin; return; }
      var t0 = null;
      function paso(t) { if (!t0) t0 = t; var p = Math.min((t - t0) / 1600, 1); el.textContent = Math.round(fin * (1 - Math.pow(1 - p, 4))); if (p < 1) requestAnimationFrame(paso); }
      el.textContent = '0'; requestAnimationFrame(paso);
    }, { threshold: 0.5 });
  }

  function magneticos() {
    if (!fino || reduce) return;
    document.querySelectorAll('[data-ep-iman]:not([data-ep-ok])').forEach(function (b) {
      b.setAttribute('data-ep-ok', '1');
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * 0.22) + 'px,' + ((e.clientY - r.top - r.height / 2) * 0.3) + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }

  function luzCursor() {
    if (!fino || reduce) return;
    document.querySelectorAll('.ep-cursor-luz:not([data-ep-ok])').forEach(function (l) {
      l.setAttribute('data-ep-ok', '1');
      var cont = l.parentElement;
      cont.addEventListener('mousemove', function (e) {
        var r = cont.getBoundingClientRect();
        l.style.left = (e.clientX - r.left) + 'px'; l.style.top = (e.clientY - r.top) + 'px';
      });
    });
  }

  function parallax() {
    if (reduce) return;
    var imgs = document.querySelectorAll('[data-ep-parallax]');
    if (!imgs.length) return;
    var tick = false;
    function upd() {
      imgs.forEach(function (img) {
        var r = img.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) return;
        var k = parseFloat(img.getAttribute('data-ep-parallax')) || 0.12;
        img.style.translate = '0 ' + ((r.top + r.height / 2 - innerHeight / 2) * -k).toFixed(1) + 'px';
      });
      tick = false;
    }
    addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  function escenas() {
    document.querySelectorAll('[data-ep-escena]:not([data-ep-ok])').forEach(function (sc) {
      sc.setAttribute('data-ep-ok', '1');
      var pasos = sc.querySelectorAll('.ep-escena__paso');
      var imgs = sc.querySelectorAll('.ep-escena__fija [data-i]');
      var marcas = sc.querySelectorAll('.ep-escena__idx i');
      function activar(i) {
        pasos.forEach(function (p, k) { p.classList.toggle('is-on', k === i); });
        imgs.forEach(function (m) { m.classList.toggle('is-on', +m.getAttribute('data-i') === i); });
        marcas.forEach(function (m, k) { m.classList.toggle('is-on', k === i); });
      }
      activar(0);
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (x) { if (x.isIntersecting) activar(+x.target.getAttribute('data-i')); });
      }, { rootMargin: '-45% 0px -45% 0px' });
      pasos.forEach(function (p) { io.observe(p); });
    });
  }

  /* Botones "#comprar": abren el formulario de pago contra entrega (Releasit).
     Si no está, usan el botón de compra del tema; si tampoco, bajan hasta el producto. */
  function botonFormulario() {
    return document.querySelector('#rsi_buy_now_button, button.rsi_animation_shake');
  }
  var irOk = false;
  function irCompra() {
    if (irOk) return; irOk = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href="#comprar"], a[href$="#comprar"], [data-ep-abrir-form]');
      if (!a) return;
      e.preventDefault();
      var b = botonFormulario();
      if (b) { b.click(); return; }
      var add = document.querySelector('product-form button[type="submit"], form[action*="/cart/add"] button[type="submit"]');
      if (add && !add.disabled) { add.click(); return; }
      var d = document.querySelector('product-info, [id^="MainProduct-"], .product');
      if (d) d.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }, true);
  }

  function todo() { partirPalabras(); reveals(); contar(); magneticos(); luzCursor(); parallax(); escenas(); irCompra(); }
  if (document.readyState !== 'loading') todo(); else document.addEventListener('DOMContentLoaded', todo);
  document.addEventListener('shopify:section:load', todo);
})();
